<template>
  <!-- 设备信息展示组件 -->
  <div v-if="currentNode.funList && currentNode.funList.length > 0" class="deviceMsg content-box forbit-cancel-tree">
    <h2>{{ $t("deviceSip.devMsg") }}</h2>
    <div class="msg-box">
      <!-- 设备名称 -->
      <h4>
        <span class="title-box">
          <i class="error-color">* </i>
          {{ $t("deviceSip.deviceName") }}
        </span>
        <span>{{ currentNode.name }}</span>
      </h4>
      <!-- 支持功能点 -->
      <h4>
        <span class="title-box">
          <i class="error-color">*</i>
          {{ $t("deviceSip.function") }}
        </span>
        <div>
          <RadioGroup v-model="currentNode.productType">
            <Radio v-for="item in allDevList" :key="item.value" :label="item.value" disabled>
              <span>{{ item.label }}</span>
            </Radio>
          </RadioGroup>
          <!-- 选择其他的设备类型，需要带出设备类型的选项 -->
          <Row v-if="Number(currentNode.productType) == 0" gutter="20" class="margin-box">
            <i-col span="22">
              <Select v-model="currentNode.deviceType" disabled :placeholder="$t('deviceType.deviceTypeTip')">
                <Option v-for="item in deviceTypeList" :key="item.value" :value="item.value">
                  {{ item.label }}
                </Option>
              </Select>
            </i-col>
          </Row>
          <CheckboxGroup v-model="currentNode.funList" class="margin-top-10">
            <Checkbox v-for="item in allFunList" :key="item.value" :label="item.value" disabled>
              <span>{{ item.label }}</span>
            </Checkbox>
          </CheckboxGroup>
        </div>
      </h4>
      <!-- 网络配置 -->
      <h4>
        <span class="error-color title-box">
          {{ $t("deviceSip.net") }}
        </span>
        <div>
          <!-- 网络类型 -->
          <h4>
            <span class="title-box"> {{ $t("deviceSip.netType") }}</span>
            <RadioGroup v-model="currentNode.netInfoDTO.mode" disabled>
              <Radio :label="1" disabled>
                <span>Static</span>
              </Radio>
            </RadioGroup>
          </h4>
          <div v-if="currentNode.netInfoDTO.mode === 1">
            <!-- 子网掩码 -->
            <h4>
              <span class="title-box">{{ $t("updateNewSip.mask") }}</span>
              <span>{{ currentNode.netInfoDTO.mask }}</span>
            </h4>
            <!-- 网关 -->
            <h4>
              <span class="title-box">{{ $t("updateNewSip.gateway") }}</span>
              <span>{{ currentNode.netInfoDTO.gateway }}</span>
            </h4>
            <!-- ip地址 -->
            <h4>
              <span class="title-box">{{ $t("updateNewSip.ip") }}</span>
              <span>{{ currentNode.netInfoDTO.ip }}</span>
            </h4>
            <!-- dns1 -->
            <h4>
              <span class="title-box">DNS1</span>
              <span>{{ currentNode.netInfoDTO.dns1 }}</span>
            </h4>
            <!-- dns2 -->
            <h4>
              <span class="title-box">DNS2</span>
              <span>{{
                currentNode.netInfoDTO.dns2
                  ? currentNode.netInfoDTO.dns2
                  : $t("updateNewSip.noData")
              }}</span>
            </h4>
          </div>
        </div>
      </h4>
      <!-- sip配置 -->
      <h4 v-for="(item, index) in currentNode.sipInfoDTOList" :key="index">
        <span class="error-color title-box">
          sip{{ index + 1 }}
          {{ $t("deviceSip.config") }}
        </span>
        <div>
          <!-- 模式 -->
          <h4>
            <span class="title-box"> {{ $t("deviceSip.mode") }}</span>
            <RadioGroup v-model="item.mode">
              <Radio :label="1" disabled>
                <span> {{ $t("deviceSip.mode1") }}</span>
              </Radio>
              <Radio :label="2" disabled>
                <span> {{ $t("deviceSip.mode2") }}</span>
              </Radio>
            </RadioGroup>
          </h4>
          <!-- 用户名 -->
          <h4>
            <span class="title-box">{{ $t("deviceSip.userTitle") }}</span>
            <span>{{ item.account }}</span>
          </h4>
          <!-- 密码 -->
          <h4 v-if="item.mode === 2">
            <span class="title-box">{{ $t("deviceSip.passwordTitle") }}</span>
            <span>{{ item.password }}</span>
          </h4>
          <h4 v-if="item.mode === 2">
            <span class="title-box">ServerIp</span>
            <span>{{ item.serviceIp }}</span>
          </h4>
          <!-- 协议类型 -->
          <h4 v-if="item.mode === 2">
            <span class="title-box">{{
              $t("deviceSip.protocolTypeTitle")
            }}</span>
            <RadioGroup v-model="item.protocolType">
              <Radio :label="1" disabled>
                <span>UDP</span>
              </Radio>
              <Radio :label="2" disabled>
                <span>TCP</span>
              </Radio>
              <Radio :label="3" disabled>
                <span>TLS</span>
              </Radio>
            </RadioGroup>
          </h4>
        </div>
      </h4>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "deviceMsg",
  components: {},
  filters: {},
  directives: {},
  mixins: {},
  props: {
    currentNode: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      deviceType: 0,
    };
  },
  computed: {
    ...mapState("projectConfig", ["allFunList", "allDevList", "deviceTypeList"]),
  },
  watch: {},
  created() { },
  mounted() { },
  beforeUpdate() { },
  beforeDestroy() { },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.content-box {
  padding-top: 30px;

  h2,
  h4 {
    display: flex;
  }

  h2 {
    margin-bottom: 30px;
  }

  h4 {
    margin-bottom: 15px;

    p {
      margin-left: 30px;
    }
  }
}

.deviceMsg {
  .msg-box {
    height: 350px;
    overflow: auto;
  }

  h4 {
    display: flex;
    margin-bottom: 15px;

    .title-box {
      display: block;
      width: 150px;
      margin-right: 20px;
      word-break: break-all;
    }
  }
}
.margin-box{
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
